var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.69131 0H18.3087C21.452 0 24 2.54799 24 5.6913V18.3087C24 21.452 21.452 24 18.3087 24H5.69131C2.548 24 0 21.452 0 18.3087V5.6913C0 2.54799 2.548 0 5.69131 0Z",
    fill: "#121D39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7593 4.58095L13.5715 4.53233C12.7107 4.51596 11.8803 4.83743 11.2582 5.44566C10.636 6.05388 10.2937 6.86799 10.2937 7.73815V9.81335H8.26068C8.17684 9.81335 8.10938 9.88082 8.10938 9.96467V12.5727C8.10938 12.656 8.17684 12.724 8.26068 12.724H10.2937V19.3222C10.2937 19.406 10.3612 19.4735 10.445 19.4735H13.1374C13.2212 19.4735 13.2887 19.406 13.2887 19.3222V12.724H15.3386C15.4145 12.724 15.479 12.6674 15.4889 12.592L15.8278 9.9845C15.8332 9.94134 15.8203 9.89819 15.7915 9.86495C15.7628 9.83221 15.7211 9.81335 15.6779 9.81335H13.2892L13.2887 8.49471C13.2882 8.48826 13.2346 7.85226 13.5665 7.48861C13.7208 7.31944 13.9316 7.23758 14.2105 7.23758H15.7573C15.8407 7.23758 15.9086 7.17011 15.9086 7.08627V4.73226C15.9071 4.6504 15.8417 4.58294 15.7593 4.58095Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookContact);
export default __webpack_public_path__ + "static/media/facebook-contact.7bf95c85fda65045b1f55e8817f1390a.svg";
export { ForwardRef as ReactComponent };